var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"flex countdown-wrapper"},[(_vm.idle)?_c('SideCountDown',{staticClass:"countdown-circle-side",attrs:{"seconds":30,"delay":"4"},on:{"countdownEnded":_vm.redirectAfterTimer}}):_vm._e()],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }